import * as Yup from 'yup';

import { Alert, Button, Col, Container, Form, Row } from 'react-bootstrap';
import { Field, Formik } from 'formik';
import React, { useState } from 'react';

import { Auth } from 'aws-amplify';
import CloseButton from '../../Styled/CloseButton';
import ErrorLabel from '../../../ui/ErrorLabel';
import LoopSpinner from '../../LoopSpinner';
import cx from 'classnames';
import modalPropTypes from '../../../propTypes/modalPropTypes';
import styled from 'styled-components';

const Description = styled.p`
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: normal;
  color: #0c1f28;
`;

const Step2 = ({ onNext, onHide, currentUser, isDeleting }) => {
  const schema = Yup.object().shape({
    password: Yup.string().trim().required('Your password is required'),
  });

  const onSubmit = async values => {
    setLoginError(undefined);
    try {
      await Auth.signIn(currentUser.attributes.email, values.password).then(
        () => onNext(values),
      );
    } catch (error) {
      setLoginError(error);
      addAlert('danger', error.message.replace('username or ', ''));
    }
  };

  // TODO: make this reusable
  const [showAlert, setShowAlert] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [loginError, setLoginError] = useState(undefined);

  const addAlert = (variant, message) => {
    setShowAlert(true);
    setAlert({ variant, message });
  };

  const hideAlert = () => {
    setShowAlert(false);
    setAlert(undefined);
  };

  return (
    <Formik
      validationSchema={schema}
      onSubmit={onSubmit}
      initialValues={{
        password: '',
      }}
      validateOnChange>
      {({ handleSubmit, isValid, isSubmitting }) => (
        <Form onSubmit={handleSubmit}>
          <Container>
            <Row>
              <Col md={10} className="mb-4">
                <h2 className="color-dark">Confirm account deletion</h2>
              </Col>
            </Row>
            <Row>
              <Col className="mb-2">
                <Description>
                  We&apos;re sorry to see you go. Once your account is deleted,
                  all of your content will be permanently gone, including your
                  account information and energy data. To confirm deletion, type
                  your password in below.
                </Description>
              </Col>
            </Row>
            {showAlert && alert && (
              <Row>
                <Col className="mb-2">
                  <Alert variant={alert.variant} onClose={() => hideAlert()}>
                    {alert.message}
                    <CloseButton onClick={() => hideAlert()} />
                  </Alert>
                </Col>
              </Row>
            )}
            <Row>
              <Col className="mb-2">
                <Field name="password">
                  {({ field, meta }) => (
                    <Form.Group controlId="password">
                      <Form.Label>Password</Form.Label>
                      <Form.Control
                        type="password"
                        value={field.value}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        isValid={!meta.error && !loginError && meta.touched}
                        className={cx({ error: !!meta.error || !!loginError })}
                        autoComplete="on"
                      />
                      {meta.error && meta.touched && (
                        <ErrorLabel label={meta.error} />
                      )}
                    </Form.Group>
                  )}
                </Field>
              </Col>
            </Row>
            {isDeleting ? (
              <Row className="mb-2">
                <Col>
                  <div className="p-5">
                    <LoopSpinner />
                    <br />
                    <h3 className="mb-3 text-center">Deleting account...</h3>
                  </div>
                </Col>
              </Row>
            ) : (
              <>
                <Row className="mb-2">
                  <Col>
                    <Button
                      className="w-100"
                      type="submit"
                      variant="primary"
                      disabled={!isValid && !isSubmitting}>
                      Confirm
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      className="w-100"
                      type="button"
                      variant="light"
                      onClick={onHide}>
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </>
            )}
          </Container>
        </Form>
      )}
    </Formik>
  );
};

Step2.propTypes = {
  ...modalPropTypes,
};

export default Step2;
